<template>
  <div>
    <!-- Basic Salary Information -->
    <!-- <v-card variant="outlined" class="pa-2">
      <v-card-title class="text-subtitle-1 mb-1 pa-2">
        <v-icon class="me-1" size="small">mdi-cash</v-icon>
        Salary Information
      </v-card-title>
      <v-form ref="salaryForm" class="pa-1">
        <v-row class="ma-0">
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="salaryInfo.effect_date"
              label="Effect Date"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="date"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-select
              v-model="salaryInfo.package"
              label="Package"
              variant="outlined"
              density="compact"
              hide-details="auto"
              :items="[
                { text: 'General Package', value: 'general' },
                { text: 'Executive Package', value: 'executive' },
                { text: 'Management Package', value: 'management' },
                { text: 'Special Package', value: 'special' }
              ]"
              item-title="text"
              item-value="value"
              clearable
            ></v-select>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="salaryInfo.gross_salary"
              label="Gross Salary"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card> -->

    <!-- Salary Information -->
    <v-card variant="outlined" class="pa-2 mt-1">
      <v-card-title class="text-subtitle-1 mb-1 pa-2">
        <v-icon class="me-1" size="small">mdi-currency-usd</v-icon>
        Salary Information
        <v-checkbox
          label="Gross Distribution Calculation"
          v-model="grossDistributionStatus"
          density="compact"
          variant="outlined"
          hide-details
          single-line
          color="primary"
          :true-value="true"
          :false-value="false"
        ></v-checkbox>
      </v-card-title>
      <v-form ref="salaryForm" class="pa-1">
        <v-row class="ma-0">
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="grossSalary"
              label="Gross Salary"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
              :disabled="totalGrossSalaryDisable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="salaryInfo.basic_salary"
              label="Basic Salary"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
              :disabled="distributedGrossSalaryDisable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="salaryInfo.house_rent"
              label="House Rent"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
              :disabled="distributedGrossSalaryDisable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="salaryInfo.medical"
              label="Medical"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
              :disabled="distributedGrossSalaryDisable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="salaryInfo.conveyance"
              label="Conveyance"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
              :disabled="distributedGrossSalaryDisable"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <!-- Salary Components -->
    <v-card variant="outlined" class="pa-2 mt-1">
      <v-card-title class="text-subtitle-1 mb-1 pa-2">
        <v-icon class="me-1" size="small">mdi-currency-usd</v-icon>
        Salary Components
      </v-card-title>

      <v-form ref="salaryComponentsForm" class="pa-1">
        <v-row class="ma-0">
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="salaryInfo.mobile"
              label="Mobile"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="salaryInfo.education"
              label="Education"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="salaryInfo.transport"
              label="Transport"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="salaryInfo.technical"
              label="Technical"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="salaryInfo.festival_allowance"
              label="Festival Allowance"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="salaryInfo.tiffin"
              label="Tiffin"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="salaryInfo.incentive"
              label="Incentive"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="salaryInfo.wash"
              label="Wash"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="salaryInfo.others"
              label="Others"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <!-- Deductions -->
    <v-card variant="outlined" class="pa-2 mt-1">
      <v-card-title class="text-subtitle-1 mb-1 pa-2">
        <v-icon class="me-1" size="small">mdi-minus-circle</v-icon>
        Deductions
      </v-card-title>

      <v-form ref="deductionsForm" class="pa-1">
        <v-row class="ma-0">
          <v-col cols="12" md="3" class="pa-1">
            <v-text-field
              v-model="salaryInfo.tax_deducted"
              label="Tax Deducted"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" class="pa-1">
            <v-text-field
              v-model="salaryInfo.car_use"
              label="Car Use"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" class="pa-1">
            <v-text-field
              v-model="salaryInfo.pf_provident_fund"
              label="PF (Provident Fund)"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" class="pa-1">
            <v-text-field
              v-model="salaryInfo.gas_bill"
              label="Gas Bill"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" class="pa-1">
            <v-text-field
              v-model="salaryInfo.electricity_bill"
              label="Electricity Bill"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" class="pa-1">
            <v-text-field
              v-model="salaryInfo.telephone_bill"
              label="Telephone Bill"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" class="pa-1">
            <v-text-field
              v-model="salaryInfo.insurance"
              label="Insurance"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" class="pa-1">
            <v-text-field
              v-model="salaryInfo.others_deducted"
              label="Others Deducted"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              prefix="৳"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <!-- Salary Summary -->
    <v-card variant="outlined" class="pa-2 mt-1">
      <v-card-title class="text-subtitle-1 mb-1 pa-2">
        <v-icon class="me-1" size="small">mdi-calculator</v-icon>
        Salary Summary
      </v-card-title>
      
      <v-row class="ma-0 pa-1">
        <v-col cols="12" md="4" class="pa-1">
          <v-text-field
            :model-value="totalSalary"
            label="Total Salary"
            variant="outlined"
            density="compact"
            hide-details="auto"
            type="number"
            prefix="৳"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="pa-1">
          <v-text-field
            :model-value="totalDeductions"
            label="Total Deductions"
            variant="outlined"
            density="compact"
            hide-details="auto"
            type="number"
            prefix="৳"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="pa-1">
          <v-text-field
            :model-value="netSalary"
            label="Net Salary"
            variant="outlined"
            density="compact"
            hide-details="auto"
            type="number"
            prefix="৳"
            readonly
            color="success"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, nextTick  } from 'vue'
import { useStore } from 'vuex'

// Props
const props = defineProps({
  salaryInfo: {
    type: Object,
    required: true
  },
  employeeId: {
    type: [String, Number],
    required: true
  }
})

// Vuex store
const store = useStore()

// Emits
const emit = defineEmits(['update:salaryInfo'])

// Forms
const salaryForm = ref(null)
const salaryComponentsForm = ref(null)
const deductionsForm = ref(null)

// --- Local refs ---
const grossSalary = ref(0)
const grossDistributionStatus = ref(true) 
const distributedGrossSalaryDisable = ref(true)
const totalGrossSalaryDisable = ref(false)
const isInitialLoad = ref(true);

// --- Sync grossDistributionStatus from props ---
watch(
  () => props.salaryInfo.gross_distribution_status,
  (val) => {
    grossDistributionStatus.value = val ?? true

    if (grossDistributionStatus.value) {
      totalGrossSalaryDisable.value = false
      distributedGrossSalaryDisable.value = true
    } else {
      totalGrossSalaryDisable.value = true
      distributedGrossSalaryDisable.value = false
    }
  },
  { immediate: true }
)

// --- Gross distribution percentages from store ---
const grossDistribution = computed(() => {
  return store.getters.getHrmEmployeeSalaryDistribution || {}
})

// --- Computed gross from components ---
const calculatedGrossFromComponents = computed(() => {
  return (
    Number(props.salaryInfo.basic_salary || 0) +
    Number(props.salaryInfo.house_rent || 0) +
    Number(props.salaryInfo.medical || 0) +
    Number(props.salaryInfo.conveyance || 0)
  )
})

// --- Watch grossSalary changes ---
watch(
  grossSalary,
  (val) => {
    if (!val) return

    // If distribution off, just set total gross
    if (!grossDistributionStatus.value) {
      props.salaryInfo.gross_salary = val
      return
    }

    // Wait until distribution percentages are loaded
    const distro = grossDistribution.value
    if (!distro || Object.keys(distro).length === 0) return

    // Apply distribution
    props.salaryInfo.gross_salary = val
    props.salaryInfo.basic_salary = val * (distro.basic || 0) / 100
    props.salaryInfo.house_rent = val * (distro.houserent || 0) / 100
    props.salaryInfo.medical = val * (distro.medical || 0) / 100
    props.salaryInfo.conveyance = val * (distro.conveyance || 0) / 100
  },
  { immediate: true }
)

watch(() => props.salaryInfo.basic_salary, (val) => {
  if (isInitialLoad.value) return  
  const distro = grossDistribution.value
  props.salaryInfo.pf_provident_fund = val * distro.pf / 100;
})

// --- Watch component sums to update grossSalary when distribution off ---
watch(calculatedGrossFromComponents, (val) => {
  if (!grossDistributionStatus.value) {
    grossSalary.value = val
  }
})

// --- Watch distribution status changes ---
watch(grossDistributionStatus, (status) => {
  props.salaryInfo.gross_distribution_status = status

  if (status) {
    totalGrossSalaryDisable.value = false
    distributedGrossSalaryDisable.value = true
  } else {
    totalGrossSalaryDisable.value = true
    distributedGrossSalaryDisable.value = false
  }
})

// --- Total salary, deductions, net salary ---
const totalSalary = computed(() => {
  const components = [
    props.salaryInfo.basic_salary || 0,
    props.salaryInfo.house_rent || 0,
    props.salaryInfo.medical || 0,
    props.salaryInfo.conveyance || 0,
    props.salaryInfo.mobile || 0,
    props.salaryInfo.education || 0,
    props.salaryInfo.transport || 0,
    props.salaryInfo.technical || 0,
    props.salaryInfo.festival_allowance || 0,
    props.salaryInfo.tiffin || 0,
    props.salaryInfo.incentive || 0,
    props.salaryInfo.wash || 0,
    props.salaryInfo.others || 0
  ]
  return Math.round(components.reduce((sum, amount) => sum + Number(amount), 0))
})

const totalDeductions = computed(() => {
  const deductions = [
    props.salaryInfo.tax_deducted || 0,
    props.salaryInfo.car_use || 0,
    props.salaryInfo.pf_provident_fund || 0,
    props.salaryInfo.gas_bill || 0,
    props.salaryInfo.electricity_bill || 0,
    props.salaryInfo.telephone_bill || 0,
    props.salaryInfo.insurance || 0,
    props.salaryInfo.others_deducted || 0
  ]
  return Math.round(deductions.reduce((sum, amount) => sum + Number(amount), 0))
})

const netSalary = computed(() => totalSalary.value - totalDeductions.value)

// --- Load store distribution if missing ---
onMounted(async () => {
  if (!store.getters.getHrmEmployeeSalaryDistribution) {
    await store.dispatch('getHrmEmployeeSalaryDistribution')
  }

  grossSalary.value = Number(props.salaryInfo.gross_salary || 0);

  // Allow a tick for watchers to settle before enabling PF auto-calc
  await nextTick()
  isInitialLoad.value = false
})

// --- Emit updates to parent ---
watch(
  () => props.salaryInfo,
  (newValue) => emit('update:salaryInfo', newValue),
  { deep: true }
)

// --- Expose validation methods ---
defineExpose({
  validateSalary: () => salaryForm.value?.validate(),
  validateComponents: () => salaryComponentsForm.value?.validate(),
  validateDeductions: () => deductionsForm.value?.validate(),
  validateAll: async () => {
    const results = await Promise.all([
      salaryForm.value?.validate(),
      salaryComponentsForm.value?.validate(),
      deductionsForm.value?.validate()
    ])
    return results.every((result) => result?.valid !== false)
  }
})
</script>
